import { gql } from '@apollo/client';

export const DUPLICATE_INPUT = gql`
  mutation duplicateInput($id: ID!) {
    input: duplicateInput(id: $id) {
      id
      description
    }
  }
`;
